import type { Sample } from './detectShots';
import type { VideoDecoder } from './videoDecoder';

const MIN_STEP_S = 0.2;
const MAX_SAMPLES = 60;

export function planSampleTimestampsS(durationS: number): number[] {
    if (durationS <= 0) return [];
    const naiveStep = Math.max(MIN_STEP_S, durationS / MAX_SAMPLES);
    const ts: number[] = [];
    for (let t = 0; t < durationS; t += naiveStep) ts.push(t);
    return ts;
}

export async function sampleFrames(decoder: VideoDecoder, durationS: number): Promise<Sample[]> {
    const ts = planSampleTimestampsS(durationS);
    const samples: Sample[] = [];
    for (const timeS of ts) {
        const canvas = await decoder.extractFrameAt(timeS);
        samples.push({ timeS, canvas });
    }
    return samples;
}
